<template>
  <base-input-group class="c-search-input" slot="reference">
    <base-input class="c-search-input__input" type="text" inputmode="search" v-focus v-model="localValue" @keyup.enter.native="$emit('search')" :placeholder="placeholder" v-bind="$attrs"/>
    <base-button class="c-search-input__button" slot="append" @click="$emit('search')">
      <font-awesome-icon class="sm:mr-2" :icon="['fal', 'search']" size="lg"/>
      <span class="hidden sm:inline">{{ $t('label.search') }}</span>
    </base-button>
  </base-input-group>
</template>

<script>
import mousetrap from 'mousetrap'

export default {
  name: 'BaseSearchInput',

  props: {
    value: {
      type: String
    },
    placeholder: {
      type: String,
      default: function () {
        return this.$i18n.t('shortcuts.pressToSearch')
      }
    }
  },

  computed: {
    localValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },

  directives: {
    focus: {
      bind: function (element) {
        mousetrap.bind('/', () => { element.focus(); return false })
      },

      unbind: function () {
        mousetrap.unbind('/')
      }
    }
  }
}
</script>
